// pages/Services.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import services from '../../data/services';
import './Services.css';

// limit: show only the first N services with a "View all" link (used on the home page)
const Services = ({ limit, showHeader = true }) => {
    const visibleServices = limit ? services.slice(0, limit) : services;

    return (
        <section id="services" className="section services">
            <div className="container">
                {showHeader && (
                    <div className="section-header">
                        <h2 className="section-title">Our Development Services</h2>
                        <p className="section-subtitle">
                            Comprehensive web solutions tailored to your business needs
                        </p>
                    </div>
                )}

                <div className="services-grid">
                    {visibleServices.map((service) => {
                        const Icon = service.icon;
                        return (
                            <div
                                key={service.slug}
                                className={`service-card card ${service.popular ? 'popular' : ''}`}
                            >
                                {service.popular && (
                                    <div className="popular-badge">Most Popular</div>
                                )}

                                <div className="service-icon">
                                    <Icon />
                                </div>

                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>

                                <ul className="service-features">
                                    {service.features.map((feature, index) => (
                                        <li key={index}>
                                            <span className="feature-check">✓</span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                <div className="service-footer">
                                    <Link to={`/services/${service.slug}`} className="btn service-btn">
                                        Learn More <FaArrowRight />
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {limit && services.length > limit && (
                    <div className="section-more">
                        <Link to="/services" className="btn btn-outline">
                            View All Services <FaArrowRight />
                        </Link>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Services;
